import React from 'react';
import classNames from 'classnames';

import {
  BusinessContactForm,
  BusinessTable,
  Button,
  InternetBanner,
  TextBlock,
} from '@/ui/index';
import { ArrRight } from '@/icons/index';

import { Questions } from '../../roaming';

import styles from './InFlight.module.scss';

const InFlight = ({ data }) => {
  return (
    <div>
      {data?.mainBanner2 && (
        <InternetBanner bannerData={data.mainBanner2} dark medium isHtml />
      )}
      <div className={'wrapper little-margin'}>
        {data?.campaignTable?.mainText && (
          <TextBlock className={classNames([styles.text, 'text--large'])}>
            {data.campaignTable.mainText}
          </TextBlock>
        )}
        {data?.campaignTable?.infoTable && (
          <BusinessTable data={data.campaignTable.infoTable} />
        )}
        <Button className={styles.button}>
          Subscribe <ArrRight width={24} />
        </Button>
      </div>
      {data?.questions && (
        <Questions
          title={null}
          className={'wrapper'}
          questions={data.questions}
        />
      )}
      {data?.banner && <BusinessContactForm bannerData={data?.banner} />}
    </div>
  );
};

export default InFlight;
